export default "/assets/images/mama-room2.63cfb99824b14d88.png";